import { isHAWB, isHBL } from "../../../features/house/houseUtils";
import QCXSelectPortoAeroportoLocalAeroportoAutocomplete from "../../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoLocalAeroportoAutocomplete";

export default function QCXAeroportoOrPortoComponent({
    id,
    key,
    name,
    label,
    disabled,
    type,
}) {

    if (isHAWB(type)) {
        return (
            <QCXSelectPortoAeroportoLocalAeroportoAutocomplete
                id={id}
                key={key}
                name={name}
                label={label}
                disabled={disabled}
            />
        );
    }

    if (isHBL(type)) {
        return (
            <QCXSelectPortoAeroportoLocalAeroportoAutocomplete
                id={id}
                key={key}
                name={name}
                label={label}
                disabled={disabled}
            />
        )
    }

}